import { useAccount, useMsal } from '@azure/msal-react';
import { Link, SxProps, Theme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import { logoutWithoutRedirect } from '../../../../lib/api/auth';

export type HambuergerMenuLoggedUserProps = {
    sx?: SxProps<Theme>;
};

const HamburgerMenuLoggedUser = ({ sx }: HambuergerMenuLoggedUserProps) => {
    const nav = useNavigate();
    const account = useAccount();
    const { instance } = useMsal();

    const onClickLogout = async () => {
        await logoutWithoutRedirect(instance);
        nav('/login');
    };

    return (
        <Link
            onClick={onClickLogout}
            sx={{
                fontWeight: 600,
                ':hover': { cursor: 'pointer' },
                textDecoration: 'none',
                ...sx
            }}>
            {account?.name}, Logout
        </Link>
    );
};

export default HamburgerMenuLoggedUser;
